import { Component, Input } from '@angular/core';

@Component({
  selector: 'copy-condition-svg',
  templateUrl: './copy.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class CopySvgComponent {
  @Input() active:boolean=false;
  @Input() direction:string='';
  @Input() color: string='';
  constructor() { }

}
